import { useEffect, useState } from 'react';

import Layout from '../layout/Layout';

import { appendCurrency, SetMeta } from '../utils/Helper/jsHelpers';

import ListingOverviewWidget from '../components/ListingOverviewWidget';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTopLevelDomain } from '../utils/translation';
import { COUNTRY_TOP_LEVEL_DOMAIN } from '../constants';
import CarFilterSection from '../components/carListingPage/CarListFilterSection';
import CarListSection from '../components/carListingPage/CarListSection';
import { decodeCompactNumber } from '../utils/Helper/PriceFormatter';

const PriceRangeListing = () => {
    const { t } = useTranslation();
    const topLevelDomain = getTopLevelDomain();

    // This ensures the page scrolls to the top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { priceRange, minMaxRange } = useParams();
    const [pageTitle, setPageTitle] = useState<string>('');
    const extractMinMax = (range: string) => {
        const [min, max] = range.split('-to-').map((value) => {
            return value;
        });
        return { min, max };
    };

    const minPrice =
        minMaxRange && decodeCompactNumber(extractMinMax(minMaxRange!)?.min);
    const maxPrice =
        minMaxRange && decodeCompactNumber(extractMinMax(minMaxRange!)?.max);

    function getMaxPriceAccToCountry() {
        switch (topLevelDomain) {
            case COUNTRY_TOP_LEVEL_DOMAIN.bj:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.ci:
                return 8000000;
            case COUNTRY_TOP_LEVEL_DOMAIN.coke:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.coza:
                return 200000;
            case COUNTRY_TOP_LEVEL_DOMAIN.ma:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.rw:
                return 15000000;
            case COUNTRY_TOP_LEVEL_DOMAIN.sn:
                return 8000000;
            case COUNTRY_TOP_LEVEL_DOMAIN.tg:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.tz:
                return 100000;
            case COUNTRY_TOP_LEVEL_DOMAIN.ug:
                return 100000;
            default:
                return 100000;
        }
    }

    const metaTitle = priceRange
        ? t('carsUnderPageTitle', {
              ns: 'meta',
              PRICE: appendCurrency(getMaxPriceAccToCountry())
          })
        : t('carsRangeListTitle', {
              ns: 'meta',
              min: appendCurrency(minPrice),
              max: appendCurrency(maxPrice)
          });

    const metaDesc = priceRange
        ? t('carsUnderPageDesc', {
              ns: 'meta',
              PRICE: appendCurrency(getMaxPriceAccToCountry())
          })
        : t('carsRangePageDesc', {
              ns: 'meta',
              min: appendCurrency(minPrice),
              max: appendCurrency(maxPrice)
          });

    useEffect(() => {
        setPageTitle(
            priceRange
                ? t('cheapestCarList', {
                      X: appendCurrency(getMaxPriceAccToCountry())
                  })
                : t('priceRangeList', {
                      min: appendCurrency(minPrice),
                      max: appendCurrency(maxPrice)
                  })
        );
    }, [priceRange, maxPrice, minPrice]);

    return (
        <>
            <SetMeta
                title={metaTitle}
                desc={metaDesc}
                keywords={t('buyPageKeywords', {
                    ns: 'meta'
                })}
                properties={[
                    {
                        key: 'og:title',
                        value: metaTitle
                    },
                    {
                        key: 'og:description',
                        value: t('carsUnderPageDesc', {
                            ns: 'meta',
                            PRICE: appendCurrency(getMaxPriceAccToCountry())
                        })
                    },
                    {
                        key: 'og:keywords',
                        value: 'buyPageKeywordsOg'
                    }
                ]}
            />
            <Layout showWhiteNavbar>
                <div className="listing-page">
                    <CarFilterSection
                        priceRange={priceRange}
                        minPriceFromURL={minPrice?.toString()}
                        maxPriceFromURL={maxPrice?.toString()}
                    />

                    <ListingOverviewWidget
                        title={pageTitle}
                        description={t('carsUnderPriceDescription')}
                    />
                    <CarListSection
                        priceRange={priceRange}
                        minPriceFromURL={minPrice?.toString()}
                        maxPriceFromURL={maxPrice?.toString()}
                    />
                </div>
            </Layout>
        </>
    );
};
export default PriceRangeListing;
